import { Box, Card, CardContent, CardMedia, Grid, Typography } from '@mui/material';
import ReusableHeadingComponents from '../../components/reusableComponents/reusableHeadingComponents';
import ReusableBtn from '../../components/reusableComponents/ReusableBtn';
import ReusableMuiIcons from '../../_helpers/ReusableMuiIcons';
import ReusableChip from '../../components/reusableComponents/chipSelector';
import { useHistory, useParams } from "react-router-dom";

export default function ViewDeliverable({ offerDetail }) {
    const BASE_URL = process.env.REACT_APP_BASEURL;
    const { offerId } = useParams();
    const history = useHistory();
    const getRedemptionSteps = (input) => {
    if (!input) return [];

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = input;

    let liItems = Array.from(tempDiv.querySelectorAll('li')).map(li =>
        li.innerHTML.trim()
    );

    if (liItems.length > 0) return liItems;

    const rawLines = input
        .split(/\n|(?=\d+\.\s)/g)
        .map(line => line.trim())
        .filter(line => line.length > 0);

    return rawLines;
};

    const deliverableDetails = getRedemptionSteps(offerDetail.redemption_steps || "");

    const targetAudience = [
        { title: "Audience Type", content: offerDetail?.audience_type?.map(d => d.type) },
        { title: "Influencer Tier", content: offerDetail?.influencer_tier?.map(d => d.influencer_type) },
        // { title: "Age Range", content: `${offerDetail?.from_age}-${offerDetail?.to_age}` },
        { title: "Gender", content: offerDetail?.gender },
         ...(Array.isArray(offerDetail?.cities) && offerDetail.cities.length > 0
        ? [{ title: "Cities", content: offerDetail.cities.map(d => d.city_name) }]
        : []),
        { title: "Audience Interest", content: offerDetail?.offer_type?.map(d => d.TypeName) },
    ];

    const renderChips = (content) =>
        (Array.isArray(content) ? content : [content]).map((item, i) => (
            <ReusableChip
                key={i}
                label={item}
                bgcolor="#E8E8E8"
                color="#7A7A7A"
                borderRadius="4px"
                sx={{ p: '15px 12px' }}
            />
        ));

    const renderTargetAudience = (items) =>
        items.map((target, idx) => (
            <Box key={idx} mb={2}>
                <Typography sx={subtitleStyle}>{target.title}</Typography>
                <Box display="flex" flexWrap="wrap" gap={1}>{renderChips(target.content)}</Box>
            </Box>
        ));

    const titleStyle = { fontWeight: 500, fontSize: 18, color: '#626478', marginBottom: '10px' };
    const subtitleStyle = { fontWeight: 500, fontSize: 16, color: '#626478', marginBottom: '10px' };

    // const handleEdit = () => {
    //     history.push(`/edit-offer/targeting/${offerId}`);
    // };

    return (
        <Box sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between" flexDirection={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }}>
                <ReusableHeadingComponents heading="Content Deliverables & Targeting" />
                {/* <ReusableBtn label="edit" icon={<ReusableMuiIcons name="edit" />} onClick={handleEdit} disabled={offerDetail?.is_draft === false} /> */}
            </Box>

            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                    <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={12}>
                            <Card sx={cardStyle}>
                                <Typography sx={titleStyle}>Content Deliverables</Typography>
                                <Box display="flex" gap={2}>
                                    <Typography sx={subtitleStyle}>No. of Deliverables</Typography>
                                    <ReusableChip
                                        label={offerDetail?.content_requirements
                                            ?.map(item => `${item.quantities} ${item.format}`)
                                            .join(' + ')}
                                        bgcolor="#E8E8E8"
                                        color="#7A7A7A"
                                        borderRadius="4px"
                                        sx={{ p: '15px 10px' }}
                                    />
                                </Box>
                            </Card>
                        </Grid>
                    </Grid>

                    <Card sx={{ ...cardStyle, mb: 3 }}>
                        <Typography sx={{ ...titleStyle }}>Target Audience</Typography>
                        <Box display="flex" flexWrap="wrap">
                            <Grid item xs={12} sm={6}>{renderTargetAudience(targetAudience.slice(0, 4))}</Grid>
                            <Grid item xs={12} sm={6}>{renderTargetAudience(targetAudience.slice(4))}</Grid>
                        </Box>
                    </Card>

                    <Card sx={{ mb: 3, borderRadius: 2 }}>
                        <CardContent sx={{ p: 3 }}>
                            <Typography variant="h6" sx={titleStyle}>Platforms To Target</Typography>
                            <Box display="flex" gap={2} flexWrap="wrap" mt={1}>
                                {/* {offerDetail?.platforms?.map((data, idx) => (
                                    <Box key={idx} display="flex" gap={2} alignItems="center" border="1px solid #E0E0E0" borderRadius="16px" p="15px 18px" width="170px">
                                        <CardMedia component="img" src={data?.platform_logo} height="20" />
                                        <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#7A7A7A' }}>{data?.platformName}</Typography>
                                    </Box>
                                ))} */}
                                {Array.isArray(offerDetail?.platforms) &&
                                    offerDetail.platforms.map((data, idx) => (
                                        <Box
                                            key={idx}
                                            display="flex"
                                            gap={2}
                                            alignItems="center"
                                            border="1px solid #E0E0E0"
                                            borderRadius="16px"
                                            p="15px 18px"
                                            width="170px"
                                        >
                                            <CardMedia component="img"
                                                //  src={data?.platform_logo} 
                                                src={`https://college.groovenexus.com/media/${data?.platform_logo}`}
                                                height="30"  sx={{width:"30px"}}/>
                                            <Typography
                                                sx={{ fontSize: '16px', fontWeight: 500, color: '#7A7A7A' }}
                                            >
                                                {data?.platformName}
                                            </Typography>
                                        </Box>
                                    ))}
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Card sx={{ ...cardStyle, height: 'fit-content' }}>
                        <Typography sx={{ ...titleStyle, mb: 3 }}>Redemption Instructions</Typography>
                        <Box display="flex" flexDirection="column" gap={2}>
                            {deliverableDetails.map((detail, idx) => (
                                <Card key={idx} sx={{ border: '1px solid #E0E0E0', borderRadius: 2, boxShadow: 'none' }}>
                                    <CardContent sx={{ p: 2 }}>
                                         <Typography sx={{ fontSize: '16px', color: '#7A7A7A', fontWeight: 400 , wordBreak: 'break-word'}} component="div" dangerouslySetInnerHTML={{ __html: detail }}/>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
}

const cardStyle = {
    p: '18px 20px',
    backgroundColor: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '10px',
    borderRadius: 2,
};
